import React from 'react';

export default function NotFound() {
  return (
      <div className="container-fluid text-center">
          <br/>
          <br/>
        <h1 className="error-title">404</h1>
        <h6 className="text-semibold content-group">Oops, an error has occurred. Page not found!</h6>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/NotFound.js